import { Status } from "@chessalpha/core";
import { gameSchema, z } from "@ssf/play-common";
import { atom, useAtomValue, useSetAtom } from "jotai";
import { useEffect, useMemo } from "react";
import { equalTo, gamesRef, orderByChild } from "../lib/firebase.js";
import { useValue } from "./useValue.js";
const userGamesAtom = atom([]);
export const useUserGames = () => useAtomValue(userGamesAtom);
const schema = z.record(gameSchema);
export const UserGames = ({ room, gid, uid, navigate, }) => {
    const setUserGames = useSetAtom(userGamesAtom);
    const valueWhite = useValue(gamesRef, room)({
        queryConstraints: useMemo(() => [orderByChild("white/uid"), equalTo(uid)], [uid]),
        disabled: !uid || !room,
        schema,
    });
    const valueBlack = useValue(gamesRef, room)({
        queryConstraints: useMemo(() => [orderByChild("black/uid"), equalTo(uid)], [uid]),
        disabled: !uid || !room,
        schema,
    });
    const games = useMemo(() => {
        if (!valueWhite.isFetched || !valueBlack.isFetched) {
            return [];
        }
        const games = [
            ...Object.entries(valueWhite.data || {}),
            ...Object.entries(valueBlack.data || {}),
        ];
        games.sort(([, a], [, b]) => a.createdAt - b.createdAt);
        return games;
    }, [valueWhite, valueBlack]);
    useEffect(() => {
        setUserGames(games);
    }, [games, setUserGames]);
    useEffect(() => {
        return () => {
            setUserGames([]);
        };
    }, [setUserGames]);
    useEffect(() => {
        const [, currentGame] = games.find(([gameId]) => gid === gameId) || [];
        if (currentGame && currentGame.status < Status.ABORTED) {
            return;
        }
        const game = games.find(([, game]) => game.status < Status.ABORTED);
        if (!game) {
            return;
        }
        const timeoutId = setTimeout(() => navigate({ room, gid: game[0] }), 3000);
        return () => clearTimeout(timeoutId);
    }, [games, gid, navigate, room]);
    return null;
};
//# sourceMappingURL=UserGames.js.map